// Element types
export const REVIEW_NAME = 'Name';
export const REVIEW_NAME_DK = 'Dit navn:';
export const REVIEW_TITLE = 'Your opinion in one sentence (title review)';
export const REVIEW_DESCRIPTION = 'Describe your experience on the camping';
export const REVIEW_DESCRIPTION_DK = 'Skriv din anmeldelse af campingpladsen:';
export const REVIEW_CATEGORY_RATINGS = 'Campsite - scores per category';
export const REVIEW_RATINGS_DK = 'Position:1';
export const REVIEW_ACCOMMODATION_RATINGS = 'Accommodation - scores per category';
export const REVIEW_PROS = 'What did you like (Pros)';
export const REVIEW_CONS = 'What didn’t you like (cons)';



// WEBPACK FOOTER //
// ./src/variables/reviewElementTypes.js